import React, { useState, useEffect } from "react";
import { TiMinus, TiPlus } from "react-icons/ti";
import { BsInfoCircle } from "react-icons/bs";
import Swal from "sweetalert2";
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import Servicios from "./servicios";
import Novedades from "./novedades";

export default function AppClientes() {
  // 🔹 Secciones plegables (ambas maximizadas)
  const [showServicios, setShowServicios] = useState(true);
  const [showNovedades, setShowNovedades] = useState(true);

  // 🔹 Permisos
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (!USERDATA || USERDATA[0]?.cierres === "false") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setHasPermission(true);
      } catch (e) {
        console.error("Error al verificar permisos:", e);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  // 🔹 Spinner de carga
  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>
          Cargando...
        </span>
        <style>{`
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  // 🔹 Sin permisos
  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  if (hasPermission !== true) return null;

  // ✅ Render principal
  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Gestión de App Clientes</h4>
      </div>

      <div className="card-body">
        {/* ========================================================= */}
        {/* 🔹 SECCIÓN 1: SERVICIOS */}
        {/* ========================================================= */}
        <div className="col-12 mt-2">
          <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
            <span>Servicios</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowServicios(!showServicios)}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showServicios}
            >
              {showServicios ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>

          {/* 💡 Info visual para Servicios */}
          <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: 14 }}>
            <BsInfoCircle size={18} className="me-2 text-primary" />
            <strong>Recomendaciones para imágenes de Servicios:</strong>
            <ul className="mb-1 mt-1">
              <li>Tamaño ideal: <b>1000 × 750 px</b> (proporción 4:3).</li>
              <li>Peso máximo: <b>1 MB</b>.</li>
              <li>Formatos permitidos: <b>JPG, PNG o WEBP</b>.</li>
              <li>La imagen debe estar centrada (el foco principal al medio).</li>
            </ul>
            <strong>Texto recomendado:</strong>
            <ul className="mb-0 mt-1">
              <li><b>Título:</b> máximo 45 caracteres.</li>
              <li><b>Descripción:</b> máximo 100 caracteres.</li>
            </ul>
          </div>
        </div>
        {showServicios && <Servicios />}

        {/* ========================================================= */}
        {/* 🔹 SECCIÓN 2: NOVEDADES */}
        {/* ========================================================= */}
        <div className="col-12 mt-4">
          <h4 className="card-title mb-2 d-flex align-items-center justify-content-between">
            <span>Novedades</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowNovedades(!showNovedades)}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showNovedades}
            >
              {showNovedades ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>

          {/* 💡 Info visual para Novedades */}
          <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: 14 }}>
            <BsInfoCircle size={18} className="me-2 text-primary" />
            <strong>Recomendaciones para imágenes de Novedades:</strong>
            <ul className="mb-1 mt-1">
              <li>Tamaño ideal: <b>1600 × 900 px</b> (proporción 16:9 tipo banner).</li>
              <li>Peso máximo: <b>1 MB</b>.</li>
              <li>Formatos permitidos: <b>JPG, PNG o WEBP</b>.</li>
              <li>Evitar texto dentro de la imagen (los textos se muestran encima).</li>
            </ul>
            <strong>Texto recomendado:</strong>
            <ul className="mb-0 mt-1">
              <li><b>Título:</b> máximo 60 caracteres.</li>
              <li><b>Descripción:</b> máximo 140 caracteres.</li>
            </ul>
          </div>
        </div>
        {showNovedades && <Novedades />}
      </div>
    </div>
  );
}
